import React from 'react';
import { Typography } from '@mui/material';

type Props = {
  title: string | React.ReactNode,
  flexGrow?: number;
}

const SubHeadingTitle: React.FC<Props> = ({
  title,
  flexGrow,
}: Props) => (
  <Typography
    flexGrow={flexGrow}
    variant="h5"
    sx={{ fontWeight: 600, color: 'primary.main' }}
  >
    {title}
  </Typography>
);

export default SubHeadingTitle;
